import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

/**
 * Centred progress for a panel that is still fetching. `inline` is the narrow
 * variant for an interior slot (a table body, a modal body) where a 240px block
 * would shove the surrounding layout around.
 */
export function LoadingState({ inline = false }: { inline?: boolean }) {
  return (
    <div
      className={cn(
        'flex items-center justify-center text-muted-foreground',
        inline ? 'py-6' : 'min-h-60',
      )}
    >
      <Spinner className={inline ? 'size-4' : 'size-5'} />
    </div>
  );
}
